import {
  LuCompass,
  LuMailOpen,
  LuUsers,
  LuCalendarPlus,
  LuHeartHandshake,
  LuSparkles,
  LuMapPin,
  LuMessageCircle,
  LuTicket,
  LuImages,
  LuRoute,
  LuStamp,
  LuTrophy,
  LuUserPlus,
  LuClipboardList,
  LuShare2,
  LuCalendarCheck,
  LuScanLine,
  LuStar,
  LuMapPinned,
  LuMap,
  LuHistory,
  LuTrees,
  LuBeer,
  LuLandmark,
} from "react-icons/lu";

// Icon names usable as "icon" in the content files.
// To add one, import it from react-icons/lu above and give it a name here.
const icons = {
  discover: LuCompass,
  people: LuUsers,
  create: LuCalendarPlus,
  community: LuHeartHandshake,
  sparkle: LuSparkles,
  location: LuMapPin,
  chat: LuMessageCircle,
  ticket: LuTicket,
  album: LuImages,
  route: LuRoute,
  stamp: LuStamp,
  score: LuTrophy,
  invite: LuUserPlus,
  list: LuClipboardList,
  share: LuShare2,
  checkin: LuCalendarCheck,
  scan: LuScanLine,
  star: LuStar,
  pin: LuMapPinned,
  map: LuMap,
  history: LuHistory,
  invitation: LuMailOpen,
  park: LuTrees,
  bar: LuBeer,
  city: LuLandmark,
};

export default icons;
